<template>
  <div class="packs">
    <h2 class="packs-text">we travel in packs</h2>
	  <picture class="packs-image">
	    <!-- <source srcset="./../assets/packs-bg-m.png" media="(max-width: 767px)"> -->
	    <img srcset="./../assets/packs-bg.png" alt="">
	  </picture>
  </div>
</template>

<script>
  export default {
    name: 'packs',
  };
</script>

<style lang='scss' scoped>
  @import './../variables';

  .packs {
  	position: relative;
  	font-size: 0;
    background-color: $flavor-blackberry;
    background-image: url(./../assets/bubly-full-1600.png);
    background-repeat: repeat-x;
    background-size: auto 30vw;
    background-position: bottom 0px center;
    height: 100vw;
    min-height: 375px;

    &-image {
      box-sizing: border-box;
      position: absolute;
      top: 35%;
      bottom: 65%;
      width: 90%;
      left: 0;
      right: 0;
      margin: auto;
      img {
        width: 100%;

      }
    }

  	&-text {
  		position: absolute;
  		top: 5%;
  		color: #FFF;
  		text-align: center;
  		font-size: 40px;
  		width: 100%;
  	}


    /* 
     * TABLET
     */

    @include breakpoint('tablet') {
      height: $packs-height-tablet;
      background-size: auto 125.8px;
      height: 375px;
 
      &-text {
        box-sizing: border-box;
        width: 50%;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        margin: 0;
        padding-left: 20px;
        font-size: 32px;
      }

       &-image {
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 50%;
        right: unset;
        width: 340px;
        margin: unset;
        bottom: unset;

        img {
          width: 100%;
        }
      }
    }

    /* 
     * LAPTOP
     */

    @include breakpoint('laptop') {
      height: $packs-height-desktop;

      &-text {
        font-size: 40px
      }

      &-image {
        width: 420px;
      }
    }

    /* 
     * DESKTOP
     */

    @include breakpoint('desktop') {
     
      &-text {
        font-size: 50px
      }

      &-image {
        width: 540px;
      }
    }

  }

 </style>



// WEBPACK FOOTER //
// src/components/Packs.vue